import { render, staticRenderFns } from "./flexes_control.vue?vue&type=template&id=8bd8bd8a"
import script from "./flexes_control.vue?vue&type=script&lang=js"
export * from "./flexes_control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports